import Swal from 'sweetalert2';

import lottie from 'lottie-web';
import animationSuccess from '../assets/animations/success.json';
import animationError from '../assets/animations/error.json';
import animationWarning from '../assets/animations/warning.json';
import animationInfo from '../assets/animations/info.json';
import animationQuestion from '../assets/animations/question.json';

const lottieMap = {
  success: animationSuccess,
  error: animationError,
  warning: animationWarning,
  info: animationInfo,
  question: animationQuestion
};

const toast = {

  close() {
    Swal.close();
  },

  loading(message, extra = {}) {
    return Swal.fire({
      title: message,
      html: extra.html,
      target: document.body,
      toast: false,
      position: 'center',
      allowOutsideClick: false,
      allowEscapeKey: false,
      scrollbarPadding: false,
      heightAuto: false,
      backdrop: true,
      showConfirmButton: false,
      showCancelButton: false,
      ...extra,
      willOpen: () => {
        Swal.showLoading();
      },
      customClass: {
        popup: 'app-swal-popup',
        ...extra.customClass,
      }
    });
  },

  success(message) {
    return fireCustomIconSwal({
      title: message,
      opts: { icon: 'success' },
      extra: {
        toast: true,
      }
    });
  },

  produtoMulti(message) {
    return fireCustomIconSwal({
      title: 'Atenção',
      message: `<div style="text-align: left; white-space: pre-line;">${message}</div>`,
      opts: { icon: 'info' },
      extra: {
        toast: true,
        timer: 7500,
        timerProgressBar: true,
        showCloseButton: true,
      }
    });
  },

  warning(message) {
    return fireCustomIconSwal({
      title: 'Atenção',
      message,
      opts: { icon: 'warning' },
      extra: {
        toast: true,
      },
    });
  },

  info(message) {
    return fireCustomIconSwal({
      title: 'Atenção',
      message,
      opts: { icon: 'info' },
      extra: {
        toast: true,
        timer: 3000
      }
    });
  },

  warningTef(message) {
    return fireCustomIconSwal({
      title: 'Atenção',
      message,
      opts: { icon: 'warning' },
      extra: {
        toast: true,
        position: 'top',
      },
    });
  },

  warningExpedicao(message) {
    return fireCustomIconSwal({
      title: 'Atenção',
      message,
      opts: { icon: 'warning' },
      extra: {
        toast: true,
        timer: 10000,
        showCloseButton: true,
        position: 'top',
      }
    });
  },

  error(message) {
    return fireCustomIconSwal({
      title: 'Ops!',
      message,
      opts: { 
        icon: 'error'
      },
      extra: {
        toast: true,
        timer: 3000
      }
    });
  },

  confirm(title, message, opts) {
    return fireCustomIconSwal({
      title,
      message,
      opts: { 
        confirmButtonText: opts?.confirmButtonText ?? 'OK',
        cancelButtonText: opts?.cancelButtonText ?? 'Cancelar',
        icon: opts?.icon === 'danger' ? 'error' : opts?.icon || 'success',
      },
      extra: {
        toast: false,
        showCancelButton: opts?.cancelButtonText === '' ? false : true,
      }
    });
  },

  show(title, message, opts, extra = {}) {
    return fireCustomIconSwal({
      title,
      message,
      opts: { 
        confirmButtonText: opts?.confirmButtonText ?? 'OK',
        icon: opts?.icon === 'danger' ? 'error' : opts?.icon || 'success',
      },
      extra: {
        toast: false,
        ...extra,
      }
    });
  },

}

const fireCustomIconSwal = ({ title, message, opts = {}, extra = {} }) => {
    const iconType = opts?.icon === 'danger' ? 'error' : opts?.icon || 'success';
    const animationData = lottieMap[iconType];
    const hasLottie = !!animationData;

    const isToast = extra?.toast ?? true;

    const showConfirmButton = isToast ? false : extra?.showConfirmButton ?? true;
    const showCancelButton = isToast ? false : extra?.showCancelButton ?? false;

    return Swal.fire({
      target: document.body,

      ...extra,

      html: hasLottie
        ? (
          isToast
            ? `
              <div style="display:flex;flex-direction:column;">
                <div style="display:flex;flex-direction:row;align-items:center">
                  <div class="swal-lottie" style="transform:scale(2.4);transform-origin:center;width: 2.8em;min-width: 2.8em;height: 2.8em;margin: 0 .5em 0 0;font-size: 1rem;"></div>
                  <h2 style="margin: 0 .625em;font-size: 1rem;flex-grow: 1;color: var(--mui-text-primary) !important;padding: 0;font-weight: 600;text-align: center;word-wrap: break-word;">${title ? title : ''}</h2>
                  ${extra?.showCloseButton ? `<button type="button" class="custom-swal2-close swal2-close" onmouseover="this.style.color='#f27474'" onmouseout="this.style.color='#ccc'" style="padding-block: 1px;padding-inline: 6px;text-align: center;text-transform: none;text-indent: 0px;text-shadow: none;letter-spacing: normal;word-spacing: normal;text-rendering: auto;box-sizing: inherit;appearance: auto;outline: 0px;box-sizing: border-box;margin: 0px;margin-top: 0.09em;font: 15px Montserrat, sans-serif;cursor: pointer;padding: .6em;overflow: hidden;transition: color .1s ease-out;border: none;border-radius: 5px;background: 0 0;color: #ccc;font-size: 1.6rem;align-items: center;justify-content: center;z-index: 2;position: static;width: .8em;height: .8em;line-height: .8;display: flex;">X</button>` : ``}
                </div>
                <div style="font-size:1em;color: var(--mui-text-secondary) !important;${message ? 'padding: .625em 0 0;margin: 0 .625em;' : ''}justify-content:center;align-items:center;">${message ? message : ''}</div>
              </div>
            `
            : `
              <div style="display:flex;flex-direction:column;${(!showConfirmButton && !showCancelButton) ? 'margin-bottom: 1.25em;' : ''}">
                <div style="display:flex;flex-direction:column;align-items:center;padding-left:1.8em;padding-right:1.8em;">
                  <div class="swal-lottie" style="transform:scale(2.4);transform-origin:center;width: 6.5em;min-width: 6.5em;height: 6.5em;margin: 1.25em auto 1.25em;font-size: 1rem;line-height: 5em;"></div>
                  <h2 style="margin: 0 0 .4em;font-size: 1.875rem;flex-grow: 1;color: var(--mui-text-primary) !important;padding: 0;font-weight: 600;text-align: center;word-wrap: break-word;">${title ? title : ''}</h2>
                </div>
                <div style="font-size:1.125rem;font-weight: 400;color: var(--mui-text-secondary) !important;justify-content:center;align-items:center;text-align:center;padding-left:1.8em;padding-right:1.8em;">${message ? message : ''}</div>
              </div>
            `
        )
        : message,

      toast: isToast,

      position: isToast ? (extra.position || 'top-end') : undefined,

      scrollbarPadding: false,
      heightAuto: false,
      backdrop: !isToast,
      timer: isToast ? (extra.timer || 2500) : undefined,
      icon: undefined,
      title: undefined,

      confirmButtonText: opts?.confirmButtonText ?? 'OK',
      cancelButtonText: opts?.cancelButtonText ?? 'Cancelar',

      showConfirmButton,
      showCancelButton,
      showCloseButton: isToast ? false : (extra?.showCloseButton ?? false),

      buttonsStyling: false,

      customClass: {
        content: 'app-swal-content',
        htmlContainer: 'app-swal-html',
        popup: 'app-swal-popup',
        confirmButton: `MuiButtonBase-root MuiButton-root MuiButton-contained priorityZIndex button-${opts?.icon ?? 'primary'}`,
        cancelButton: 'MuiButtonBase-root MuiButton-root MuiButton-contained priorityZIndex button-white'
      },

      didOpen: (popup) => {
        const closeButton = popup.querySelector('.custom-swal2-close');
        closeButton?.addEventListener('click', () => {
          Swal.close();
        });
        const lottieContainer = popup.querySelector('.swal-lottie');
        if (lottieContainer && hasLottie) {
          lottie.loadAnimation({
            container: lottieContainer,
            renderer: 'svg',
            loop: false,
            autoplay: true,
            animationData
          });
        }
      },

    });
  }

export default toast;
